import { render } from "./UpcomingEvents.vue?vue&type=template&id=7433a794&scoped=true"
import script from "./UpcomingEvents.vue?vue&type=script&lang=js"
export * from "./UpcomingEvents.vue?vue&type=script&lang=js"

import "./UpcomingEvents.vue?vue&type=style&index=0&id=7433a794&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7433a794"]])

export default __exports__